import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PaginatedResponse } from '../../interfaces/pagination';
import { AuthPermission } from '../../../pages/manage-users/models/permission';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private http: HttpClient = inject(HttpClient);

  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';

  getAllCustomPermissions(
    page = 1,
    pageSize = 100,
  ): Observable<PaginatedResponse<AuthPermission>> {
    const params = { page: page.toString(), page_size: pageSize.toString() };
    return this.http.get<PaginatedResponse<AuthPermission>>(
      `${this.adminApiBaseUrl}/permissions`,
      { params },
    );
  }
}
